import { BusinessColId, BusinessColumnDef } from "constants/columnDefinitions";
import {
  ManualAdjustmentColId,
  ManualAdjustmentColumnDef,
} from "constants/columnDefinitions/manualAdjustment";

import { booleanRenderer } from "lib/agGrid/renderers";

/**
 * We are displaying label reversed to what the data columns due to a shift to sundry templates.
 * This may be fixed one day??
 */

export const columnDefs = [
  ...Object.values(ManualAdjustmentColumnDef),
  {
    ...BusinessColumnDef[BusinessColId.NAME],
    colId: ManualAdjustmentColId.FROM_BUSINESS,
    field: "fromBusiness.name",
    headerName: "Paid To Business",
    cellRendererParams: {
      businessKey: "manualAdjustment.fromBusinessId",
    },
  },
  {
    colId: ManualAdjustmentColId.EMAIL_ATTACHMENTS_TO_FROM_BUSINESS,
    cellRenderer: booleanRenderer,
    field: "manualAdjustment.emailAttachmentsToFromBusiness",
    headerName: "Send Files to Paid To Business",
    width: 240,
  },
  {
    ...BusinessColumnDef[BusinessColId.NAME],
    colId: ManualAdjustmentColId.TO_BUSINESS,
    field: "toBusiness.name",
    headerName: "Paid From Business",
    cellRendererParams: {
      businessKey: "manualAdjustment.toBusinessId",
    },
  },
  {
    cellRenderer: booleanRenderer,
    colId: ManualAdjustmentColId.EMAIL_ATTACHMENTS_TO_TO_BUSINESS,
    field: "manualAdjustment.emailAttachmentsToToBusiness",
    headerName: "Send Files to Paid From Business",
    width: 240,
  },
];
